export default __webpack_public_path__ + "static/media/NoRecentActivityIcon.2ae9ca64.svg";